module.exports = __webpack_public_path__ + "media/images/smart_phone/post_kuchikomi_btn_s_ov3-d4d57ad9341a2ae923abb2717a26b823.png";